import {Inject, Injectable} from '@angular/core';

interface WindowWithDatalayer extends  Window {
  dataLayer: any[];
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticService {
  constructor(
    @Inject('Window') private window: WindowWithDatalayer,
  ) {
  }

  public push(event: string) {
    if (this.window.dataLayer) {
      this.window.dataLayer.push({event});
    }
  }
}
